import wixWindow from 'wix-window'
import wixLocation from 'wix-location'
import wixSeo from 'wix-seo'
import { session } from 'wix-storage'

import { BI_EVENTS, PAGE_PATH_TO_CATEGORY } from 'public/biConsts'
import { sendBi, getOriginForBI, storeOriginForBI, removeOriginFromStorage } from 'public/biModule'

const isMobile = wixWindow.formFactor === 'Mobile'
const isBrowser = wixWindow.rendering.env === 'browser' // not SSR

$w.onReady(function () {
    setBIOriginForMenu()

    setTimeout(() => {
        handleBI()
    }, 100)

    savePreviousPageURL()
    wixLocation.onChange(() => {
        savePreviousPageURL()
    })
})

const setBIOriginForMenu = () => {
    if (!isMobile) {
        if ($w('Page').rendered) {
            $w('Page').onClick(() => {
                removeOriginFromStorage()
            })
        }

        $w('#headerMenuContainer').onClick(() => {
            storeOriginForBI({ origin: 'menu', ignoreURLValidation: true })
        })
    }
}

const handleBI = () => {
    const { OPEN_PAGE, ITEM_CLICKED } = BI_EVENTS

    const referral_url = wixWindow.referrer ?
        wixWindow.referrer : session.getItem('previousPageURL')
    const origin = getOriginForBI()
    // console.log({ origin })

    const page_name = wixSeo.title // Note: You should always invoke the wixSeo.title getter outside of the onReady() event handler to ensure receiving the proper response
    const [, path] = wixLocation.path
    const prefix = wixLocation.prefix // This might be redundant
    const pageSlug = prefix ? prefix : path
    const category = pageSlug ? PAGE_PATH_TO_CATEGORY[pageSlug] : 'main_page'

    if (isBrowser) { // not SSR
        sendBi(OPEN_PAGE, { page_name, category, referral_url, origin })

        if (!isMobile) {
            $w('#startProjectHeader').onClick(() => {
                sendBi(
                    ITEM_CLICKED,
                    Object.assign({
                        page_name: 'home_page',
                        origin: 'start_project_header',
                        link_type: 'site_selector',
                        referral_url: wixWindow.referrer ? wixWindow.referrer : session.getItem('previousPageURL'),
                        related_link: $w('#startProjectHeader').link
                    })
                )
            })
        }
    }
}

const savePreviousPageURL = () => {
    const wasRefreshed = wixLocation.url === session.getItem('currentPageURL')
    if (!wasRefreshed) {
        session.setItem('previousPageURL', session.getItem('currentPageURL'))
        session.setItem('currentPageURL', wixLocation.url)
    }
}

// intended  to clear errors from the monitor
export function header1_mouseIn(event) {}
export function enterHeader(event) {}
export function leaveHeader(event) {}